<template>
  <span
    class="label"
    :class="{
      'label-primary': value === 1,
      'label-info': value === 2,
      'label-danger': value === 3
    }"
  >
    <span v-html="label"></span>
  </span>
</template>

<script>
export default {
  name: 'nivel-label',
  props: ['value'],
  data() {
    return {
      niveis: {
        1: 'COLABORADOR',
        2: 'GESTOR',
        3: 'ADMINISTRADOR'
      }
    }
  },
  mounted() {},
  computed: {
    label() {
      return this.niveis[parseInt(this.value)]
    }
  }
}
</script>

<style lang="css"></style>
